import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Layout, Menu } from 'antd';
import Icon, {
  BookOutlined,
  CalendarOutlined, 
  CrownOutlined,
  TrophyOutlined,
} from '@ant-design/icons';
import type { MenuProps } from 'antd';
import BrainIcon from './BrainIcon';
import './Navigation.css';

const { Header } = Layout;

const GameControllerSvg: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg
    {...props}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M17.32 5H6.68a4 4 0 0 0-3.98 3.59l-.7 7A3 3 0 0 0 5 19c.8 0 1.55-.31 2.12-.88L9.24 16h5.52l2.12 2.12A3 3 0 0 0 22 15.59l-.7-7A4 4 0 0 0 17.32 5Z" />
    <path d="M6 11h4M8 9v4" />
    <path d="M15 12h.01M18 10h.01" />
  </svg>
);
const Navigation: React.FC = () => {
  const location = useLocation();

  const navItems = [
    { path: '/ask', label: 'Historian', icon: <BookOutlined /> },
    { path: '/records', label: 'Records', icon: <TrophyOutlined /> },
    { path: '/seasons', label: 'Seasons', icon: <CalendarOutlined /> },
    { path: '/all-gibson', label: 'All Gibson', icon: <CrownOutlined /> },
    { path: '/analytics', label: 'Intelligence', icon: <BrainIcon /> },
    { path: '/games', label: 'Games', icon: <Icon component={GameControllerSvg} aria-hidden="true" /> },
  ];

  const selectedPath = navItems.find(item => (
    item.path === '/'
      ? location.pathname === '/'
      : location.pathname === item.path || location.pathname.startsWith(`${item.path}/`)
  ))?.path;

  const menuItems: MenuProps['items'] = navItems.map(item => ({
    key: item.path,
    icon: item.icon,
    label: (
      <Link to={item.path} style={{ textDecoration: 'none' }}>
        {item.label}
      </Link>
    ),
  }));

  return (
    <Header className="main-navigation">
      <div className="nav-brand">
        <Link to="/" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
          <img 
            src="/logo_white.png" 
            alt="Gibsons League" 
            className="nav-brand-logo"
          />
          <span className="nav-brand-text">Gibsons League</span>
        </Link>
      </div>
      
      {/* Desktop Menu */}
      <Menu
        theme="dark"
        mode="horizontal"
        selectedKeys={selectedPath ? [selectedPath] : []}
        items={menuItems}
        className="nav-menu desktop-menu"
      />
      
      {/* Mobile Menu */}
      <div className="mobile-menu">
        {navItems.map(item => (
          <Link
            key={item.path}
            to={item.path}
            className={`mobile-nav-item ${selectedPath === item.path ? 'active' : ''}`}
          >
            {item.icon}
            <span className="mobile-nav-label">{item.label}</span>
          </Link>
        ))}
      </div>
    </Header>
  );
};

export default Navigation;
